// Presentation adapter only. The shared runtime owns catalog, accounts and audio.
import { runtime } from '../../bridge';
import { workspace } from '../../workspace';
import { readWorkspaceFeedPages, rememberWorkspaceFeedPages } from '../../workspace-view-state';

export function pushOnlineQuery(vm, patch) {
  const query = { ...vm.$route.query, ...patch };
  for (const key of Object.keys(query)) if (query[key] === undefined || query[key] === '') delete query[key];
  return vm.$router.push({ path: vm.$route.path, query, hash: vm.$route.hash }).catch(error => {
    if (error.name !== 'NavigationDuplicated') runtime.notify(error.message || '无法更新在线分类', 'error');
  });
}

export default {
  data() { return { items: [], loading: false, error: '', more: false, cursor: 0, loadedPages: 0, requestId: 0, feedActive: true, loadedFeedKey: '', feedOwnerMode: workspace.mode }; },
  watch: { feedKey: { immediate: true, handler() { if (this.feedActive) this.loadFeed(false); } } },
  activated() {
    this.feedActive = true;
    if (this.loading) return;
    if (this.feedKey !== this.loadedFeedKey) this.loadFeed(false);
    else if (this.more && this.loadedPages < readWorkspaceFeedPages(this.feedOwnerMode, this.$options.name + ':' + this.feedKey)) this.loadFeed(true);
  },
  deactivated() { this.feedActive = false; this.requestId++; this.loading = false; },
  beforeDestroy() { this.feedActive = false; this.requestId++; },
  methods: {
    async loadFeed(append = false) {
      if (!this.feedActive || workspace.mode !== this.feedOwnerMode || append && this.loading) return;
      const request = ++this.requestId;
      const feedKey = this.feedKey;
      const ownerMode = this.feedOwnerMode;
      const storageKey = this.$options.name + ':' + feedKey;
      const savedPages = Math.max(1, Math.min(10, readWorkspaceFeedPages(ownerMode, storageKey)));
      const targetPages = append ? Math.max(this.loadedPages + 1, savedPages) : savedPages;
      const current = () => request === this.requestId && feedKey === this.feedKey && this.feedActive && workspace.mode === ownerMode;
      const seenCursors = new Set();
      this.loading = true;
      this.error = '';
      if (!append) { this.items = []; this.cursor = 0; this.more = false; this.loadedPages = 0; }
      try {
        let appendPage = append;
        do {
          if (!current()) return;
          const cursor = appendPage ? this.cursor : 0;
          if (seenCursors.has(String(cursor))) { this.more = false; break; }
          seenCursors.add(String(cursor));
          const result = await this.fetchFeed(cursor);
          if (!current()) return;
          if (!Array.isArray(result.items)) throw new Error('来源返回了无效列表，请重试。');
          const seen = new Set(appendPage ? this.items.map(item => String(item.id)) : []);
          const additions = result.items.filter(item => { const id = String(item.id); if (seen.has(id)) return false; seen.add(id); return true; });
          this.items = appendPage ? [...this.items, ...additions] : additions;
          this.loadedPages = appendPage ? this.loadedPages + Number(additions.length > 0) : 1;
          this.cursor = result.nextCursor || this.items.length;
          this.more = Boolean(result.more) && additions.length > 0 && !seenCursors.has(String(this.cursor));
          this.loadedFeedKey = feedKey;
          appendPage = true;
        } while (this.more && this.loadedPages < targetPages);
        if (current()) rememberWorkspaceFeedPages(ownerMode, storageKey, this.loadedPages);
      } catch (error) {
        if (current()) this.error = error.message || '在线内容加载失败，请重试。';
      } finally {
        if (current()) this.loading = false;
      }
    },
  },
};
